import { create } from "zustand"

const sidebarStore = create((set) => ({
    section: null,
    sidebarIsOpen: true,
    useMouseHover: false,

    collapseButtonOnClick: () =>
        set((state) => ({ ...state, useMouseHover: !state.useMouseHover, sidebarIsOpen: state.useMouseHover })),
    setSidebarIsOpen: (isOpen) =>
        set((state) => {
            return { ...state, sidebarIsOpen: isOpen }
        }),
    setSection: (section) => set((state) => ({ ...state, section })),
}))

export default sidebarStore
